"use client";

import { apiRemote, IDashboardIndonesiaCompetitonCourses, IDashboardCheckPaymentStatusApiExtend } from "@/api";
import he from 'he';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  LinearProgress,
  Pagination,
  PaginationItem,
  IconButton,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { useDashboardContext } from "./Layout";
import logo from '../../images/imgcourse.png';
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import OpenEnrolCourseOrderDialog from "./RequestEnrolCourseDialog";
import { useUser } from "@/contexts/UserContext";

// Custom SVG icon for the course
const CourseIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="100" height="100" rx="4" fill="#1a237e" />
    <path d="M30 25h40v35h-40z" fill="#fff" />
    <path d="M35 65h30v10h-30z" fill="#fff" />
    <circle cx="50" cy="42" r="15" fill="#1a237e" />
    <path d="M45 42l5 5 8-8" stroke="#fff" strokeWidth="2" />
  </svg>
);

// Custom right chevron icon
const ChevronRightIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18L15 12L9 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const decodeHTMLEntities = (text: any) => {
  const textArea = document.createElement("textarea")
  textArea.innerHTML = text
  return textArea.value
}

export interface IDashboardIndonesiaCompetitonCoursesExtend extends IDashboardIndonesiaCompetitonCourses {}

export default function IndonesiaCompetitonCourses() {
  const [courses, setCourses] = useState<IDashboardIndonesiaCompetitonCourses["data"]["courses"]>([]);

  const [orderStatus, setOrderStatus] = useState<IDashboardCheckPaymentStatusApiExtend["data"]>([]);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const { getDashboardIndonesiaCompetitonCourses } = useDashboardContext();
  const { checkPaymentStatusApi } = useDashboardContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openDialog, setOpenDialog] = useState(false);
  const [initialData, setInitialData] = useState<any>(null);

  const [paymentStatus, setPaymentStatus] = useState<{ [key: number]: number }>({});

  var { user } = useUser();

  const reloadData = useCallback(() => {
    setLoading(true);
    console.log("Reloading with page:", currentPage);
    
    getDashboardIndonesiaCompetitonCourses(currentPage.toString(), pageSize.toString())
      .then((data) => {
        setCourses(data.data.courses);
        setTotalPages(Number(data.data.totalpage));
        setCount(data.data.courses.length);
      })
      .catch((error) => {
        console.error(error?.message || "Failed to load data.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, pageSize]);  // Thêm `currentPage` vào dependency

  useEffect(() => {
    reloadData();
  }, [currentPage, reloadData]);  // Gọi lại khi `currentPage` thay đổi

  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     setLoading(true); // Bắt đầu tải dữ liệu
  //     try {
        
  //       const res = await getDashboardIndonesiaCompetitonCourses(currentPage.toString(), pageSize.toString());
  //       setCourses(res.data.courses);
  //       setTotalPages(Number(res.data.totalpage));
  //       setCount(res.data.courses.length);
  //     } catch (error) {
  //       console.error("Error fetching badges:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchCourses();
  // }, [currentPage, pageSize]);

  useEffect(() => {
    courses.forEach(course => {
      if (course.categoryid == process.env.CATEGORY_COURSE_PAID) {
        // const res = await checkPaymentStatusApi(course.id);
        apiRemote.checkPaymentStatusApi(course.id.toString()).then((data: any)=>{
          if (data?.status === "success" && data?.data?.check_course_order) {
            setPaymentStatus(prevState => ({
              ...prevState,
              [course.id]: data.data.order_status
            }));
          }
        }).catch((e: any)=>{
          console.log(e)
        })
      }
    });
  }, [courses]);

  useEffect(() => {
    if(isMobile){
      setPageSize(1)
    }else{
      setPageSize(4)
    }
  }, [isMobile]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        mt: 4,
        flex: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "rgb(15, 105, 185)",
          fontWeight: 500,
          mb: 3,
        }}
      >
        Indonesia Competition Courses
      </Typography>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <CircularProgress />
        </Box>
      ) : count === 0 ?  (
        <Typography
          sx={{
            color: "rgb(102, 102, 102)",
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          No data available
        </Typography>
      ) : (
        <>
          <Box sx={{ position: "relative", mb: 3 }}>
            <Grid container spacing={3} sx={{ mb: 3 }}>
              {courses.map((course: any) => (
                <Grid item xs={12} sm={6} md={3} key={course.id}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      bgcolor: "rgb(247, 250, 255)",
                      border: "1px solid rgb(237, 242, 247)",
                      boxShadow: "none",
                      borderRadius: 2,
                    }}
                  >
                    <CardMedia
                      component="div"
                      sx={{
                        pt: "56.25%",
                        position: "relative",
                        bgcolor: "white",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: '100%',
                          height: '100%'
                        }}
                      >
                        <img
                          src={course.course_image || logo}
                          alt={course.fullname.toString()}
                          width="100%"
                          height="100%"
                          style={{
                            objectFit: 'cover'
                          }}
                        />
                      </Box>
                    </CardMedia>
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          mb: 2,
                          fontSize: '16px',
                          fontWeight: 600,
                          lineHeight: '24px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          height: '48px',
                          bgcolor: 'transparent'
                        }}
                      >
                        {he.decode(course.fullname)}
                      </Typography>
                      <Box sx={{ flex: 1 }}>
                        <Typography 
                          variant="body2" 
                          sx={{ 
                            mb: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical'
                          }}
                        >
                          {course.summary ? decodeHTMLEntities(course.summary.replace(/<[^>]*>/g, "")) : ""}
                        </Typography>
                      </Box>

                      <Box sx={{ mt: "auto" }}>

                        {course.categoryid == process.env.CATEGORY_COURSE_PAID ? 
                          <Button
                            onClick={() => {
                              if (!paymentStatus[course.id] || paymentStatus[course.id] !== 1) {
                                const costField = course.customfields.find(field => field.shortname == "cost");
                                const currencyField = course.customfields.find(field => field.shortname == "currency");
                                const forApprovalField = course.customfields.find(field => field.shortname == "forapproval");

                                const courseCost = costField?.valueraw || costField?.value || "N/A";
                                const courseCurrency = currencyField?.valueraw || currencyField?.value || "N/A";
                                const courseForApproval = forApprovalField?.valueraw || forApprovalField?.value || "";
                          
                                setInitialData({ course_id: course.id, course_name: course.fullname, cost: courseCost, currency: courseCurrency, for_approval: courseForApproval, user: user, course: course });
                                setOpenDialog(true);
                              }
                            }}
                            fullWidth
                            variant="contained"
                            sx={{
                              bgcolor: paymentStatus[course.id] === 3 ? "gray" :
                                      paymentStatus[course.id] === 1 ? "green" :
                                      "rgb(255, 90, 31)",
                              "&:hover": {
                                bgcolor: paymentStatus[course.id] === 3 ? "gray" :
                                        paymentStatus[course.id] === 1 ? "green" :
                                        "rgb(230, 81, 28)",
                              },
                            }}
                            disabled={paymentStatus[course.id] === 1 || paymentStatus[course.id] === 3}
                          >
                            {paymentStatus[course.id] === 3
                              ? "Waiting for approval"
                              : paymentStatus[course.id] === 1
                              ? "Enrolled"
                              : `${course.customfields?.find(f => f.shortname === "cost")?.value || "N/A"} 
                                ${course.customfields?.find(f => f.shortname === "currency")?.value || "N/A"} to Enroll`}
                          </Button>
                        
                        : 
                          <Button
                            href={course.view_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            fullWidth
                            variant="contained"
                            sx={{
                              bgcolor: "rgb(255, 90, 31)",
                              "&:hover": {
                                bgcolor: "rgb(230, 81, 28)",
                              },
                            }}
                          >
                            Free to Enroll 
                          </Button>
                        }
                        
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <IconButton
              onClick={handlePrevPage} // Chuyển trang về trước
              sx={{
                position: "absolute",
                left: -16,
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "white",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                "&:hover": {
                  bgcolor: "rgb(247, 250, 255)",
                },
              }}
            >
              <ArrowBackIos />
            </IconButton>
            
            <IconButton
              onClick={handleNextPage} // Chuyển trang tới tiếp theo
              sx={{
                position: "absolute",
                right: -16,
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "white",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                "&:hover": {
                  bgcolor: "rgb(247, 250, 255)",
                },
              }}
            >
              <ArrowForwardIos />
            </IconButton>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              shape="rounded"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  sx={{
                    "&.Mui-selected": {
                      bgcolor: "rgb(15, 105, 185)",
                      color: "white",
                      "&:hover": {
                        bgcolor: "rgb(13, 94, 166)",
                      },
                    },
                  }}
                />
              )}
            />
          </Box>
        </>
      )}

      <OpenEnrolCourseOrderDialog open={openDialog} onClose={()=>{setOpenDialog(false)}} initialData={initialData} reloadData={reloadData}/>
    </Box>
  );
}
